$ = require('jquery');

$('footer svg.arrow-long').on('click', () => {
    $([document.documentElement, document.body]).animate({
        scrollTop: $('#entry-content').offset().top -250
    }, 1000);
});

// ? CASB
const scrollToCategory = () => {
    const url = window.location.href;
    const category = url.split('category=')[1];
    const isCategoryValid = category !== undefined;
    let headingID;

    if (isCategoryValid) {
        headingID = category.split(',')[0];
    }

    const categoryHeading = $(`.supplier-table__row[data-category*="${headingID}"]`);

    console.log('target h3', categoryHeading);
    console.log('heading ID', headingID);

    if (categoryHeading.length > 0) {
        $('html, body').animate({
            scrollTop: categoryHeading.offset().top - 250
        }, 1000);
    }
}

export default scrollToCategory;